<template>
    <b-badge :variant="row.IsUpToDate ? 'success' : 'danger'" class="font-weight-bolder text-nowrap">
        {{ row.IsUpToDate ? 'Güncel' : 'Güncel Değil' }}
    </b-badge>
</template>

<script>
import { BBadge } from 'bootstrap-vue'
export default {
    components:{
        BBadge
    },
    props:{
        row:Object,
        field:[Object,String]
    },
}
</script>

<style>

</style>